import React from 'react';
interface DataBadgeProps {
  mode: 'live' | 'snapshot' | 'loading';
  source: string;
  asOf?: string;
}
export function DataBadge({
  mode,
  source,
  asOf
}: DataBadgeProps) {
  const label = mode === 'live' ? 'Live' : mode === 'snapshot' ? 'Snapshot' : 'Loading';
  const dot = mode === 'live' ? 'bg-live' : mode === 'snapshot' ? 'bg-machine' : 'bg-faint motion-safe:animate-pulse';
  return <span className="inline-flex max-w-full items-center gap-2 rounded-full border border-line bg-surface px-2.5 py-1 font-mono text-[11px] text-muted" data-id="element-214" data-mp="j1qpe1ej1723">
      <span className={`h-1.5 w-1.5 shrink-0 rounded-full ${dot}`} aria-hidden="true" data-id="element-215" data-mp="nza3n1b85ju1" />
      <span className="text-ink" data-id="element-216" data-mp="95nh0dt30c6p">{label}</span>
      <span className="truncate" data-id="element-217" data-mp="e2x9k2brp3yr">
        {source}
        {asOf ? ` · as of ${asOf}` : ''}
      </span>
    </span>;
}